document.addEventListener("DOMContentLoaded", () => {



//to add animation to the header lines on appearance//
  const observer = new IntersectionObserver(
    entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add("is-visible");
          observer.unobserve(entry.target); // animate once
        }
      });
    },
    { threshold: 0.3 }
  );

  
  document.querySelectorAll(".h1").forEach(el => {
    observer.observe(el);
  });
//to add animation to the header lines on appearance//






});